export const prepareImageInitValues = (data) => {
  return {
    unique_id: Date.now(),
    released_at: data?.released_at,
    released_to: data?.released_to,
    use_utc_zero_time: data?.use_utc_zero_time ?? false,
  };
};

export const prepareCollectionInitValues = (collectionDetails) => {
  return {
    update_image_release_dates: false,
    released_at: collectionDetails?.released_at,
    released_to: collectionDetails?.released_to,
    use_utc_zero_time: collectionDetails?.use_utc_zero_time,
    template_id: collectionDetails?.template?.data?.id,
    preset_id: null,
    title: collectionDetails?.title,
    categories: collectionDetails?.categories?.data?.map((category) => category.id),
    image_type: collectionDetails?.image_type,
    is_published: false,
    updated_at: collectionDetails?.updated_at,
    published_at: collectionDetails?.published_at,
    target: {
      min_version: collectionDetails?.target?.data?.min_version ?? '',
      max_version: collectionDetails?.target?.data?.max_version ?? '',
      platform: collectionDetails?.target?.data?.platform,
      countries: [ ...collectionDetails?.target?.data?.countries ?? [] ].sort(),
    },
    data: {},
  };
};
